import React, { useState, useEffect, useRef, useCallback } from 'react';
const api = async (sti, metode = 'GET', data = null) => {
 const res = await fetch('/api' + sti, {
 method: metode,
 credentials: 'include',
 headers: {
 'Content-Type': 'application/json',
 },
 body: data ? JSON.stringify(data) : null,
 });
 if (!res.ok) {
 const err = await res.json().catch(() => ({}));
 throw new Error(err.fejl || `HTTP ${res.status}`);
 }
 return res.json();
};
const upload_fil = async (fil) => {
 const fd = new FormData();
 fd.append('fil', fil);
 const res = await fetch('/api/os/chief/upload', {
 method: 'POST',
 credentials: 'include',
 body: fd,
 });
 if (!res.ok) {
 const err = await res.json().catch(() => ({}));
 throw new Error(err.fejl || `Upload fejlede`);
 }
 return res.json();
};
const C = {
 bg: '#060917',
 sidebar: 'rgba(4,6,18,0.85)',
 kort: 'rgba(8,12,30,0.60)',
 kant: 'rgba(255,255,255,0.08)',
 tekst: '#e2e8f0',
 subtekst: '#7a8fa6',
 primary: '#2322be',
 accent: '#3fd4c7',
 ok: '#22c55e',
 advarsel: '#f59e0b',
 kritisk: '#ef4444',
 valgt: 'rgba(35,34,190,0.22)',
};
// ── Fil-type ikon ──────────────────────────────────────────
function FilIkon({ mime }) {
 if (mime?.startsWith('image/')) return '';
 if (mime === 'application/pdf') return '';
 if (mime?.includes('word')) return '';
 return '';
}
// ── Fil-chip (til input-området) ──────────────────────────
function FilChip({ fil, onFjern }) {
 return (
 <div style={{
 display: 'flex', alignItems: 'center', gap: 5,
 padding: '3px 8px 3px 6px',
 background: 'rgba(35,34,190,0.15)',
 border: `1px solid rgba(35,34,190,0.30)`,
 borderRadius: 20, fontSize: 12, color: C.accent,
 maxWidth: 160,
 }}>
 {fil.preview ? (
 <img src={fil.preview} alt="" style={{ width: 18, height: 18, objectFit: 'cover', borderRadius: 3 }} />
 ) : (
 <span style={{ fontSize: 14 }}><FilIkon mime={fil.mime_type} /></span>
 )}
 <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
 {fil.uploading ? ' ' : ''}{fil.filnavn}
 </span> <button onClick={() => onFjern(fil.lokalt_id)} style={{
 background: 'none', border: 'none', color: C.subtekst,
 cursor: 'pointer', padding: 0, fontSize: 13, lineHeight: 1,
 }}>×</button> </div>
 );
}
// ── Vedhæftede filer i chatbesked ─────────────────────────
function FilListe({ filer }) {
 if (!filer || filer.length === 0) return null;
 return (
 <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
 {filer.map(f => (
 <div key={f.id} style={{
 display: 'flex', alignItems: 'center', gap: 4,
 padding: '2px 8px', borderRadius: 12,
 background: 'rgba(255,255,255,0.06)',
 border: `1px solid ${C.kant}`,
 fontSize: 11, color: C.subtekst,
 }}> <span><FilIkon mime={f.mime_type} /></span> <span>{f.filnavn}</span> </div>
 ))}
 </div>
 );
}
// ── Forslag-kort ───────────────────────────────────────────
function ForslagKort({ forslag, onSend, sender, historisk }) {
 const sendt = forslag.beskrivelse?.startsWith('');
 const fejl = forslag.beskrivelse?.startsWith('');
 return (
 <div style={{
 margin: '10px 0 0',
 padding: 14,
 background: 'rgba(35,34,190,0.10)',
 border: `1px solid rgba(35,34,190,0.30)`,
 borderRadius: 10,
 borderLeft: `4px solid ${sendt ? C.ok : fejl ? C.kritisk : C.primary}`,
 }}> <div style={{ fontSize: 10, color: C.accent, fontWeight: 700, letterSpacing: '0.08em', marginBottom: 5 }}>
 FORSLAG TIL GODKENDELSE
 </div> <div style={{ fontSize: 13, fontWeight: 700, color: C.tekst, marginBottom: 5 }}>{forslag.titel}</div> <div style={{ fontSize: 12, color: C.subtekst, lineHeight: 1.55, marginBottom: 10, whiteSpace: 'pre-wrap' }}>
 {forslag.beskrivelse}
 </div>
 {!historisk && !sendt && (
 <button
 onClick={onSend}
 disabled={sender}
 style={{
 background: sender ? 'rgba(35,34,190,0.3)' : C.primary,
 color: '#fff', border: 'none', borderRadius: 7,
 padding: '7px 14px', fontSize: 12, fontWeight: 600,
 cursor: sender ? 'not-allowed' : 'pointer',
 }}
 >
 {sender ? 'Sender…' : '→ Send til godkendelseskøen'}
 </button>
 )}
 </div>
 );
}
// ── Chat-besked ────────────────────────────────────────────
function ChatBesked({ besked }) {
 const erCos = besked.rolle === 'cos';
 return (
 <div style={{
 display: 'flex', justifyContent: erCos ? 'flex-start' : 'flex-end',
 marginBottom: 14, gap: 8, alignItems: 'flex-start',
 }}>
 {erCos && (
 <div style={{
 width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
 background: `linear-gradient(135deg, ${C.primary}, ${C.accent})`,
 display: 'flex', alignItems: 'center', justifyContent: 'center',
 fontSize: 15, marginTop: 2,
 }}></div>
 )}
 <div style={{ maxWidth: '74%' }}>
 {erCos && (
 <div style={{ fontSize: 10, color: C.subtekst, marginBottom: 3, fontWeight: 600 }}>
 Chief of Staff · {new Date(besked.tidspunkt).toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' })}
 </div>
 )}
 <div style={{
 padding: '11px 14px',
 background: erCos ? 'rgba(8,12,30,0.70)' : 'rgba(35,34,190,0.18)',
 border: `1px solid ${erCos ? C.kant : 'rgba(35,34,190,0.28)'}`,
 borderRadius: erCos ? '4px 14px 14px 14px' : '14px 4px 14px 14px',
 fontSize: 14, color: C.tekst, lineHeight: 1.6,
 whiteSpace: 'pre-wrap', backdropFilter: 'blur(8px)',
 }}>
 {besked.indhold}
 </div>
 {!erCos && <FilListe filer={besked.filer} />}
 {erCos && besked.forslag && (
 <ForslagKort
 forslag={besked.forslag}
 onSend={besked.onSendForslag}
 sender={besked.senderForslag}
 historisk={besked.historisk}
 />
 )}
 </div>
 {!erCos && (
 <div style={{
 width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
 background: 'rgba(255,255,255,0.09)',
 display: 'flex', alignItems: 'center', justifyContent: 'center',
 fontSize: 14, marginTop: 2,
 }}></div>
 )}
 </div>
 );
}
// ── Metrik-linje ───────────────────────────────────────────
function MetrikLinje({ m }) {
 return (
 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '4px 0', borderBottom: `1px solid rgba(255,255,255,0.04)` }}> <span style={{ fontSize: 11, color: C.subtekst, flex: 1 }}>{m.metrik_navn}</span> <span style={{ fontSize: 12, fontWeight: 700, color: C.tekst, marginLeft: 6 }}>
 {m.vaerdi?.toLocaleString('da-DK')}{m.enhed ? ' ' + m.enhed : ''}
 </span> </div>
 );
}
// ── Session-item i sidebar ─────────────────────────────────
function SessionItem({ s, aktiv, onValg, onSlet }) {
 const [hover, setHover] = useState(false);
 const dato = new Date(s.opdateret_kl).toLocaleDateString('da-DK', { day: 'numeric', month: 'short' });
 return (
 <div
 onClick={() => onValg(s.id)}
 onMouseEnter={() => setHover(true)}
 onMouseLeave={() => setHover(false)}
 style={{
 display: 'flex', alignItems: 'center', gap: 6,
 padding: '8px 10px', borderRadius: 8, marginBottom: 2,
 cursor: 'pointer',
 background: aktiv ? C.valgt : hover ? 'rgba(255,255,255,0.04)' : 'transparent',
 borderLeft: aktiv ? `3px solid ${C.primary}` : '3px solid transparent',
 transition: 'all .12s',
 }}
 > <div style={{ flex: 1, minWidth: 0 }}> <div style={{
 fontSize: 12, color: aktiv ? C.accent : C.tekst,
 overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
 fontWeight: aktiv ? 600 : 400,
 }}>
 {s.titel}
 </div> <div style={{ fontSize: 10, color: C.subtekst, marginTop: 1 }}>
 {dato} · {s.beskeder || 0} beskeder
 </div> </div>
 {hover && (
 <button
 onClick={e => { e.stopPropagation(); onSlet(s.id); }}
 title="Slet samtale"
 style={{
 background: 'none', border: 'none', color: C.subtekst,
 cursor: 'pointer', padding: '2px 4px', fontSize: 14,
 borderRadius: 4, flexShrink: 0,
 ':hover': { color: C.kritisk },
 }}
 >×</button>
 )}
 </div>
 );
}
// ── Session-sidebar ────────────────────────────────────────
function SessionSidebar({ sessioner, aktivId, onValg, onNy, onSlet, søg, setSøg, lader }) {
 const filtreret = sessioner.filter(s =>
 s.titel.toLowerCase().includes(søg.toLowerCase())
 );
 return (
 <div style={{
 width: 210, flexShrink: 0,
 display: 'flex', flexDirection: 'column',
 background: C.sidebar,
 border: `1px solid ${C.kant}`,
 borderRadius: 12,
 overflow: 'hidden',
 }}>
 {/* Header */}
 <div style={{ padding: '14px 12px 10px', borderBottom: `1px solid ${C.kant}` }}> <div style={{ fontSize: 10, color: C.subtekst, fontWeight: 700, letterSpacing: '0.1em', marginBottom: 8 }}>
 SAMTALER
 </div> <button
 onClick={onNy}
 disabled={lader}
 style={{
 width: '100%', padding: '7px 10px',
 background: `rgba(35,34,190,0.15)`,
 border: `1px solid rgba(35,34,190,0.30)`,
 borderRadius: 7, color: C.accent, fontSize: 12,
 fontWeight: 600, cursor: lader ? 'not-allowed' : 'pointer',
 transition: 'all .12s', display: 'flex', alignItems: 'center', gap: 6,
 }}
 onMouseEnter={e => !lader && (e.currentTarget.style.background = 'rgba(35,34,190,0.25)')}
 onMouseLeave={e => (e.currentTarget.style.background = 'rgba(35,34,190,0.15)')}
 > <span style={{ fontSize: 16 }}>+</span> Ny samtale
 </button> </div>
 {/* Søgning */}
 <div style={{ padding: '8px 10px', borderBottom: `1px solid ${C.kant}` }}> <input
 value={søg}
 onChange={e => setSøg(e.target.value)}
 placeholder="Søg i historik…"
 style={{
 width: '100%', padding: '5px 8px',
 background: 'rgba(255,255,255,0.04)',
 border: `1px solid ${C.kant}`,
 borderRadius: 6, color: C.tekst,
 fontSize: 12, outline: 'none', boxSizing: 'border-box',
 }}
 /> </div>
 {/* Liste */}
 <div style={{ flex: 1, overflowY: 'auto', padding: '6px 6px', scrollbarWidth: 'thin', scrollbarColor: `${C.kant} transparent` }}>
 {filtreret.length === 0 ? (
 <div style={{ fontSize: 11, color: C.subtekst, textAlign: 'center', padding: '16px 8px', fontStyle: 'italic' }}>
 {søg ? 'Ingen resultater' : 'Ingen samtaler endnu'}
 </div>
 ) : (
 filtreret.map(s => (
 <SessionItem key={s.id} s={s} aktiv={s.id === aktivId} onValg={onValg} onSlet={onSlet} />
 ))
 )}
 </div> </div>
 );
}
// ═══════════════════════════════════════════════════════════
// HOVED-KOMPONENT
// ═══════════════════════════════════════════════════════════
export default function ChiefOfStaff() {
 const [sessioner, setSessioner] = useState([]);
 const [aktivSession, setAktivSession] = useState(null); // { id, titel }
 const [historik, setHistorik] = useState([]);
 const [input, setInput] = useState('');
 const [loader, setLoader] = useState(false);
 const [sessLader, setSessLader] = useState(false);
 const [kontekst, setKontekst] = useState(null);
 const [forslagStatus, setForslagStatus] = useState({});
 const [søg, setSøg] = useState('');
 const [filer, setFiler] = useState([]); // pending vedhæftninger
 const [dragOver, setDragOver] = useState(false);
 const chat_bund = useRef(null);
 const input_ref = useRef(null);
 const fil_input = useRef(null);
 // Hent sessioner + kontekst ved mount
 useEffect(() => {
 api('/os/chief/sessioner').then(d => setSessioner(d.sessioner || [])).catch(() => {});
 api('/os/chief/kontekst').then(setKontekst).catch(() => {});
 }, []);
 // Auto-scroll til bund
 useEffect(() => {
 chat_bund.current?.scrollIntoView({ behavior: 'smooth' });
 }, [historik]);
 // Indlæs session fra DB
 const indlæs_session = useCallback(async (id) => {
 setSessLader(true);
 try {
 const d = await api(`/os/chief/sessioner/${id}`);
 setAktivSession({ id: d.id, titel: d.titel });
 const msgs = (d.historik || []).map((h, i) => ({
 ...h,
 id: `hist-${i}`,
 historisk: true,
 }));
 setHistorik(msgs);
 setFiler([]);
 setInput('');
 } catch {
 // Session ikke tilgængelig
 } finally {
 setSessLader(false);
 }
 }, []);
 // Ny session
 const ny_session = useCallback(async () => {
 setSessLader(true);
 try {
 const d = await api('/os/chief/sessioner', 'POST');
 setSessioner(prev => [{ id: d.id, titel: d.titel, oprettet_kl: d.oprettet_kl, opdateret_kl: d.oprettet_kl, beskeder: 0 }, ...prev]);
 setAktivSession({ id: d.id, titel: d.titel });
 setHistorik([]);
 setFiler([]);
 setInput('');
 } catch {}
 finally { setSessLader(false); }
 }, []);
 // Slet session
 const slet_session = useCallback(async (id) => {
 try {
 await api(`/os/chief/sessioner/${id}`, 'DELETE');
 setSessioner(prev => prev.filter(s => s.id !== id));
 if (aktivSession?.id === id) {
 setAktivSession(null);
 setHistorik([]);
 setFiler([]);
 }
 } catch {}
 }, [aktivSession]);
 // Upload filer
 const upload_filer = useCallback(async (file_list) => {
 const ny_filer = Array.from(file_list).map(f => ({
 lokalt_id: Math.random().toString(36).slice(2),
 filnavn: f.name,
 mime_type: f.type,
 preview: f.type.startsWith('image/') ? URL.createObjectURL(f) : null,
 uploading: true,
 id: null,
 _fil: f,
 }));
 setFiler(prev => [...prev, ...ny_filer]);
 // Upload asynkront
 for (const nf of ny_filer) {
 try {
 const result = await upload_fil(nf._fil);
 setFiler(prev => prev.map(f =>
 f.lokalt_id === nf.lokalt_id
 ? { ...f, id: result.id, uploading: false }
 : f
 ));
 } catch {
 setFiler(prev => prev.map(f =>
 f.lokalt_id === nf.lokalt_id
 ? { ...f, uploading: false, fejl: true }
 : f
 ));
 }
 }
 }, []);
 const fjern_fil = useCallback((lokalt_id) => {
 setFiler(prev => {
 const f = prev.find(x => x.lokalt_id === lokalt_id);
 if (f?.preview) URL.revokeObjectURL(f.preview);
 return prev.filter(x => x.lokalt_id !== lokalt_id);
 });
 }, []);
 // Drag-and-drop
 const on_drag_over = useCallback(e => { e.preventDefault(); setDragOver(true); }, []);
 const on_drag_leave = useCallback(() => setDragOver(false), []);
 const on_drop = useCallback(e => {
 e.preventDefault();
 setDragOver(false);
 upload_filer(e.dataTransfer.files);
 }, [upload_filer]);
 // Send besked
 const send = useCallback(async () => {
 const besked = input.trim();
 if (!besked || loader) return;
 if (filer.some(f => f.uploading)) return; // Vent på upload
 const fil_ids = filer.filter(f => f.id).map(f => f.id);
 const fil_meta = filer.filter(f => f.id).map(f => ({ id: f.id, filnavn: f.filnavn, mime_type: f.mime_type }));
 const bruger_msg = {
 id: Date.now(),
 rolle: 'bruger',
 indhold: besked,
 tidspunkt: new Date().toISOString(),
 filer: fil_meta,
 };
 setHistorik(h => [...h, bruger_msg]);
 setInput('');
 setFiler([]);
 setLoader(true);
 try {
 const data = await api('/os/chief/chat', 'POST', {
 besked,
 session_id: aktivSession?.id || null,
 filer: fil_ids,
 });
 // Opdater session-id hvis ny session blev oprettet
 const ny_sid = data.session_id;
 if (!aktivSession) {
 const ny_titel = besked.slice(0, 60);
 setAktivSession({ id: ny_sid, titel: ny_titel });
 setSessioner(prev => [{
 id: ny_sid, titel: ny_titel,
 oprettet_kl: new Date().toISOString(),
 opdateret_kl: new Date().toISOString(),
 beskeder: 2,
 }, ...prev.filter(s => s.id !== ny_sid)]);
 } else {
 // Opdater session-liste (titel + besked-antal + tidspunkt)
 setSessioner(prev => prev.map(s =>
 s.id === aktivSession.id
 ? { ...s, opdateret_kl: new Date().toISOString(), beskeder: (s.beskeder || 0) + 2 }
 : s
 ));
 // Opdater titel hvis det var første besked
 if (historik.filter(h => h.rolle === 'bruger' && !h.historisk).length === 0) {
 setAktivSession(prev => ({ ...prev, titel: besked.slice(0, 60) }));
 }
 }
 const msg_id = Date.now();
 setHistorik(h => [...h, {
 id: msg_id,
 rolle: 'cos',
 indhold: data.svar,
 forslag: data.forslag || null,
 tidspunkt: new Date().toISOString(),
 }]);
 } catch (err) {
 setHistorik(h => [...h, {
 id: Date.now(),
 rolle: 'cos',
 indhold: `Beklager — jeg kunne ikke svare. Fejl: ${err.message}`,
 tidspunkt: new Date().toISOString(),
 }]);
 } finally {
 setLoader(false);
 setTimeout(() => input_ref.current?.focus(), 50);
 }
 }, [input, loader, filer, aktivSession, historik]);
 // Send forslag til godkendelseskøen
 const send_forslag = useCallback(async (msg_id, forslag) => {
 setForslagStatus(s => ({ ...s, [msg_id]: 'sender' }));
 try {
 await api('/os/chief/forslag', 'POST', forslag);
 setForslagStatus(s => ({ ...s, [msg_id]: 'sendt' }));
 } catch {
 setForslagStatus(s => ({ ...s, [msg_id]: 'fejl' }));
 }
 }, []);
 const START_BESKEDER = [
 'Hvad er de vigtigste prioriteter denne uge?',
 'Hvad er status på omsætningsmålet?',
 'Hvilke KPIs mangler vi live-data på?',
 'Hvad skal vi gøre med Facebook-gruppen?',
 'Lav et budget-forslag til næste kvartal',
 ];
 const har_ventende_uploads = filer.some(f => f.uploading);
 return (
 <div
 className="sv-chief-layout"
 style={{
 display: 'flex', gap: 16, height: 'calc(100vh - 72px)',
 fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
 }}
 onDragOver={on_drag_over}
 onDragLeave={on_drag_leave}
 onDrop={on_drop}
 >
 {/* ── Session-sidebar ── */}
 <SessionSidebar
 sessioner={sessioner}
 aktivId={aktivSession?.id}
 onValg={indlæs_session}
 onNy={ny_session}
 onSlet={slet_session}
 søg={søg}
 setSøg={setSøg}
 lader={sessLader}
 />
 {/* ── Chat ── */}
 <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, position: 'relative' }}>
 {/* Drag-over overlay */}
 {dragOver && (
 <div style={{
 position: 'absolute', inset: 0, zIndex: 10,
 background: 'rgba(35,34,190,0.12)',
 border: `2px dashed ${C.primary}`,
 borderRadius: 12,
 display: 'flex', alignItems: 'center', justifyContent: 'center',
 backdropFilter: 'blur(4px)',
 }}> <div style={{ fontSize: 18, color: C.accent, fontWeight: 700 }}>
 Slip filen her
 </div> </div>
 )}
 {/* Header */}
 <div style={{
 padding: '14px 20px',
 background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)',
 borderRadius: '0 0 14px 14px', marginBottom: 16,
 display: 'flex', alignItems: 'center', gap: 12,
 }}> <div style={{
 width: 44, height: 44, borderRadius: '50%',
 background: `linear-gradient(135deg, ${C.primary}, ${C.accent})`,
 display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20,
 }}></div> <div> <div style={{ fontSize: 16, fontWeight: 800, color: '#f1f5f9' }}>Chief of Staff</div> <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>
 {aktivSession ? aktivSession.titel : 'Vælg en samtale eller start ny'}
 </div> </div> <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6 }}> <div style={{ width: 7, height: 7, borderRadius: '50%', background: C.ok, boxShadow: `0 0 5px ${C.ok}` }} /> <span style={{ fontSize: 11, color: C.ok, fontWeight: 600 }}>Online</span> </div> </div>
 {/* Beskeder */}
 <div style={{
 flex: 1, overflowY: 'auto', padding: '0 2px',
 scrollbarWidth: 'thin', scrollbarColor: `${C.kant} transparent`,
 }}>
 {sessLader ? (
 <div style={{ textAlign: 'center', padding: 40, color: C.subtekst, fontSize: 13 }}>
 Henter samtale…
 </div>
 ) : historik.length === 0 ? (
 <div style={{ textAlign: 'center', padding: '32px 16px' }}> <div style={{ fontSize: 36, marginBottom: 10 }}></div> <div style={{ fontSize: 15, color: C.tekst, fontWeight: 600, marginBottom: 6 }}>God dag, René</div> <div style={{ fontSize: 13, color: C.subtekst, marginBottom: 24, lineHeight: 1.6 }}>
 {aktivSession
 ? 'Ny samtale — hvad skal vi arbejde på?'
 : 'Vælg en tidligere samtale eller start en ny.'}
 </div> <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, justifyContent: 'center' }}>
 {START_BESKEDER.map((t, i) => (
 <button key={i} onClick={() => { setInput(t); input_ref.current?.focus(); }} style={{
 background: 'rgba(35,34,190,0.10)', border: `1px solid rgba(35,34,190,0.22)`,
 color: C.accent, borderRadius: 18, padding: '6px 12px',
 fontSize: 12, cursor: 'pointer', transition: 'all .12s',
 }}
 onMouseEnter={e => e.currentTarget.style.background = 'rgba(35,34,190,0.20)'}
 onMouseLeave={e => e.currentTarget.style.background = 'rgba(35,34,190,0.10)'}
 >{t}</button>
 ))}
 </div> </div>
 ) : (
 historik.map(msg => (
 <ChatBesked
 key={msg.id}
 besked={{
 ...msg,
 onSendForslag: msg.forslag && !msg.historisk ? () => send_forslag(msg.id, msg.forslag) : undefined,
 senderForslag: forslagStatus[msg.id] === 'sender',
 forslag: msg.forslag
 ? forslagStatus[msg.id] === 'sendt'
 ? { ...msg.forslag, beskrivelse: ' Sendt til Renés godkendelseskø' }
 : forslagStatus[msg.id] === 'fejl'
 ? { ...msg.forslag, beskrivelse: ' Kunne ikke sende — prøv igen' }
 : msg.forslag
 : null,
 }}
 />
 ))
 )}
 {loader && (
 <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 14 }}> <div style={{
 width: 32, height: 32, borderRadius: '50%',
 background: `linear-gradient(135deg, ${C.primary}, ${C.accent})`,
 display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15,
 }}></div> <div style={{ padding: '11px 14px', background: 'rgba(8,12,30,0.70)', border: `1px solid ${C.kant}`, borderRadius: '4px 14px 14px 14px' }}> <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
 {[0,1,2].map(i => (
 <div key={i} style={{
 width: 6, height: 6, borderRadius: '50%', background: C.accent, opacity: 0.6,
 animation: `pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
 }} />
 ))}
 </div> </div> </div>
 )}
 <div ref={chat_bund} /> </div>
 {/* Input */}
 <div style={{ padding: '12px 0 0', borderTop: `1px solid ${C.kant}`, marginTop: 10 }}>
 {/* Fil-chips */}
 {filer.length > 0 && (
 <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, marginBottom: 8 }}>
 {filer.map(f => (
 <FilChip key={f.lokalt_id} fil={f} onFjern={fjern_fil} />
 ))}
 </div>
 )}
 <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
 {/* Fil-upload knap */}
 <button
 onClick={() => fil_input.current?.click()}
 title="Vedhæft fil (billeder, PDF, DOCX — maks 20 MB)"
 style={{
 width: 38, height: 38, borderRadius: 10, border: `1px solid ${C.kant}`,
 background: 'rgba(8,12,30,0.70)', color: C.subtekst,
 cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
 fontSize: 16, flexShrink: 0, transition: 'all .12s',
 }}
 onMouseEnter={e => { e.currentTarget.style.borderColor = C.primary; e.currentTarget.style.color = C.accent; }}
 onMouseLeave={e => { e.currentTarget.style.borderColor = C.kant; e.currentTarget.style.color = C.subtekst; }}
 ></button> <input
 ref={fil_input}
 type="file"
 multiple
 accept="image/*,application/pdf,.docx,.txt"
 style={{ display: 'none' }}
 onChange={e => { upload_filer(e.target.files); e.target.value = ''; }}
 /> <textarea
 ref={input_ref}
 value={input}
 onChange={e => setInput(e.target.value)}
 onKeyDown={e => {
 if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(); }
 }}
 placeholder="Skriv til Chief of Staff… (Enter = send · Shift+Enter = ny linje · slip fil her)"
 rows={2}
 style={{
 flex: 1, padding: '10px 14px',
 background: 'rgba(8,12,30,0.70)',
 border: `1px solid ${dragOver ? C.primary : C.kant}`,
 borderRadius: 10, color: C.tekst, fontSize: 14, lineHeight: 1.5,
 resize: 'none', outline: 'none', fontFamily: 'inherit',
 transition: 'border-color .12s',
 }}
 onFocus={e => e.target.style.borderColor = C.primary}
 onBlur={e => e.target.style.borderColor = C.kant}
 disabled={loader}
 /> <button
 onClick={send}
 disabled={loader || !input.trim() || har_ventende_uploads}
 title={har_ventende_uploads ? 'Vent på at filer er uploadet…' : 'Send (Enter)'}
 style={{
 width: 42, height: 42, borderRadius: '50%', border: 'none',
 background: (loader || !input.trim() || har_ventende_uploads) ? 'rgba(35,34,190,0.25)' : C.primary,
 color: '#fff', fontSize: 17,
 cursor: (loader || !input.trim() || har_ventende_uploads) ? 'not-allowed' : 'pointer',
 display: 'flex', alignItems: 'center', justifyContent: 'center',
 transition: 'all .12s', flexShrink: 0,
 }}
 >↑</button> </div> <div style={{ fontSize: 10, color: C.subtekst, marginTop: 5, paddingLeft: 2 }}>
 Chief of Staff foreslår · René godkender · Du kan vedhæfte billeder, PDF og DOCX
 </div> </div> </div>
 {/* ── Kontekst-panel ── */}
 <div style={{ width: 228, flexShrink: 0 }}> <div style={{
 background: 'rgba(8,12,30,0.60)', border: `1px solid ${C.kant}`,
 borderRadius: 12, padding: 14,
 backdropFilter: 'blur(16px)',
 position: 'sticky', top: 0,
 }}> <div style={{ fontSize: 10, color: C.subtekst, fontWeight: 700, letterSpacing: '0.1em', marginBottom: 10 }}>
 LIVE KONTEKST
 </div>
 {kontekst?.metrikker?.length > 0 ? (
 kontekst.metrikker.map(m => <MetrikLinje key={m.metrik_kode} m={m} />)
 ) : (
 <div style={{ fontSize: 11, color: C.subtekst, fontStyle: 'italic' }}>Henter data…</div>
 )}
 {kontekst?.afventende_beslutninger > 0 && (
 <div style={{
 marginTop: 12, padding: '7px 10px',
 background: 'rgba(245,158,11,0.09)', border: `1px solid rgba(245,158,11,0.22)`,
 borderRadius: 7,
 }}> <div style={{ fontSize: 11, color: C.advarsel, fontWeight: 700 }}>
 {kontekst.afventende_beslutninger} afventende beslutning{kontekst.afventende_beslutninger !== 1 ? 'er' : ''}
 </div> <div style={{ fontSize: 10, color: C.subtekst, marginTop: 1 }}>Kræver Renés svar</div> </div>
 )}
 <div style={{ marginTop: 12, fontSize: 10, color: C.subtekst, lineHeight: 1.5, borderTop: `1px solid ${C.kant}`, paddingTop: 10 }}> <strong style={{ color: C.tekst, display: 'block', marginBottom: 3 }}>Live data</strong>
 Chief of Staff henter automatisk sager, KPIer og beslutninger via tools når du spørger.
 </div> <div style={{ marginTop: 10, fontSize: 10, color: C.subtekst, lineHeight: 1.5, borderTop: `1px solid ${C.kant}`, paddingTop: 10 }}> <strong style={{ color: C.tekst, display: 'block', marginBottom: 3 }}>Workflow</strong>
 Chief of Staff foreslår →<br />
 René godkender →<br />
 System implementerer
 </div> </div> </div> <style>{`
 @keyframes pulse {
 0%, 100% { opacity: 0.3; transform: scale(0.8); }
 50% { opacity: 1; transform: scale(1.1); }
 }
 `}</style> </div>
 );
}